export interface SerpResultGq {
  id: number;
  projectId: number;
  title?: string;
  description?: string;
  url?: string;
  domain?: string;
  breadcrumb?: string;
  rankCombined: number;
  type: string;
  ctr: number;
}

export const SerpResultGqProps = `
  id
  projectId
  title
  description
  url
  domain
  breadcrumb
  rankCombined
  type
  ctr
`;
